import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spacer } from '@cleartrip/bento';
import { isEmpty } from 'helper/isEmpty';

import StatusLoading from './loader';

import { travelStatusGetApi } from 'api/travelsafe';

function CurrentTravelStatus({ variant }) {
	let statusSchema = {
		flightsTookOff: { count: '', increase: '', decrease: '' },
		passengersFlew: { count: '', increase: '', decrease: '' },
		bookingMade: '',
		timeStamp: '',
		lastUpdated: '',
		calculatedFrom: '',
		airportsOperated: '',
		airlinesOperated: ''
	};

	const [loading, setLoading] = useState(false);
	const [status, setStatus] = useState(statusSchema);

	const getTravelStatus = async (domain) => {
		try {
			const response = await travelStatusGetApi(domain);
			if (!isEmpty(response) ) {
				setStatus(response);
			}
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (variant === 'UAE') getTravelStatus('ct.ae');
		else getTravelStatus();
		setLoading(true);
	}, []);

	let StatusBlock = '';

	if (loading) {
		StatusBlock = <StatusLoading />;
	} else {
		StatusBlock = (
			<>
				{variant === 'UAE' && (
					<div className='flex flex-between flex-middle pb-3'>
						<p className='fs-4 fw-500 c-neutral-700'>On {status.timeStamp}</p>
						{status.lastUpdated && <p className='d-none--xs c-neutral-400 fs-2'>Last updated: {status.lastUpdated}</p>}
					</div>
				)}
				<Card className='bc-neutral-100 ba br-4  px-4 py-4'>
					{variant !== 'UAE' && (
						<>
							<p className='fs-4 c-neutral-900'>On {status.timeStamp}</p>
							<Spacer className='pt-3' />
						</>
					)}

					<Row>
						<Col span={5} xs={12}>
							<div className='flex'>
								{variant === 'UAE' && <Spacer className='pr-5 d-none--xs' />}
								<div>
									<div className='fs-2 fw-500 c-error-500 h-4'></div>
									<p className='fs-8 fw-500 c-neutral-900'>{status.bookingMade}</p>
									<p className='fs-2 c-neutral-700'>Bookings made</p>
								</div>
							</div>
						</Col>
						<Col span={5} xs={12}>
							{status.flightsTookOff.increase ? (
								<div className='fs-2 fw-500 c-success-500 h-4'>{status.flightsTookOff.increase} ↑</div>
							) : status.flightsTookOff.decrease ? (
								<div className='fs-2 fw-500 c-error-500 h-4'>{status.flightsTookOff.decrease} ↑</div>
							) : (
								<div className='fs-2 fw-500 c-error-500 h-4'></div>
							)}
							<p className='fs-8 fw-500 c-neutral-900'>{status.flightsTookOff.count}</p>
							<p className='fs-2 c-neutral-700'>Flights took off</p>
						</Col>

						<Col span={5} xs={12}>
							<Spacer className='pt-5--xs' />
							{status.passengersFlew.increase ? (
								<div className='fs-2 fw-500 c-success-500 h-4'>{status.passengersFlew.increase} ↑</div>
							) : status.passengersFlew.decrease ? (
								<div className='fs-2 fw-500 c-error-500 h-4'>{status.passengersFlew.decrease} ↓</div>
							) : (
								<div className='fs-2 fw-500 c-error-500 h-4'></div>
							)}
							<p className='fs-8 fw-500 c-neutral-900'>{status.passengersFlew.count}</p>
							<p className='fs-2 c-neutral-700'>Passengers flew</p>
						</Col>
						{status.airportsOperated && (
							<Col span={5} xs={12}>
								<Spacer className='pt-5--xs' />
								<div className='fs-2 fw-500 c-success-500 h-4'></div>
								<p className='fs-8 fw-500 c-neutral-900'>{status.airportsOperated}</p>
								<p className='fs-2 c-neutral-700'>Airports operated</p>
							</Col>
						)}

						{status.airlinesOperated && (
							<Col span={4} xs={12}>
								<div className='fs-2 fw-500 c-success-500 h-4'></div>
								<p className='fs-8 fw-500 c-neutral-900'>{status.airlinesOperated}</p>
								<p className='fs-2 c-neutral-700'>Airlines operated</p>
							</Col>
						)}
					</Row>
				</Card>
				<Spacer className='pt-3' />
				{status.calculatedFrom && (
					<p className='flex flex-right c-neutral-400 fs-2'>
						<span className='c-success-500'>↑</span>
						<span className='c-error-500'>↓</span>&nbsp;calculated from: {status.calculatedFrom}{' '}
					</p>
				)}
			</>
		);
	}

	return <>{StatusBlock}</>;
}

export default CurrentTravelStatus;
